import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

export interface TableActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive';
  icon?: LucideIcon;
  children: React.ReactNode;
}

export const TableActionButton = React.forwardRef<
  HTMLButtonElement,
  TableActionButtonProps
>(({ className, variant = 'default', icon: Icon, children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center font-medium transition-colors whitespace-nowrap',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:pointer-events-none disabled:opacity-50 select-none',
        'shadow-sm h-7 px-2 text-xs gap-1 rounded-md',
        '[&_svg]:h-3 [&_svg]:w-3',
        variant === 'default' && [
          'border border-border/60 bg-background text-foreground',
          'hover:border-border hover:bg-accent/5'
        ],
        variant === 'destructive' && [
          'border border-red-200 bg-background text-red-700',
          'hover:bg-red-50 hover:border-red-300 hover:text-red-800'
        ],
        className
      )}
      {...props}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {children}
    </button>
  );
});

TableActionButton.displayName = 'TableActionButton';

